import request from "@/utils/request";
import requestToken from "@/utils/requestToken";

// 获取当前时间
export function getCurrentTime() {
  const val = new Date();
  const y = val.getFullYear();
  const m = (val.getMonth() + 1).toString().padStart(2, "0");
  const d = val
    .getDate()
    .toString()
    .padStart(2, "0");
  const h = val
    .getHours()
    .toString()
    .padStart(2, "0");
  const mi = val
    .getMinutes()
    .toString()
    .padStart(2, "0");
  const s = val
    .getSeconds()
    .toString()
    .padStart(2, "0");
  return `${y}-${m}-${d} ${h}:${mi}:${s}`;
}

// 获取当前日期
export function getCurrentDay() {
  const val = new Date();
  const y = val.getFullYear();
  const m = (val.getMonth() + 1).toString().padStart(2, "0");
  const d = val
    .getDate()
    .toString()
    .padStart(2, "0");
  return `${y}-${m}-${d}`;
}

//登录
export function getLogin(parameter) {
  return requestToken({
    url: "/app/login",
    method: "post",
    params: parameter
  });
}

//获取工程
export function getEngineerList(parameter) {
  return request({
    url: "/sso/api/sso/base/ssoEngineering/listByUser",
    method: "get",
    params: parameter
  });
}
//获取标段
export function getSectionList(parameter) {
  return request({
    url: "/sso/api/sso/base/ssoSection/listByUser",
    method: "get",
    params: parameter
  });
}
//获取视频
export function getChannelsList(parameter) {
  return request({
    url: "/sso/api/sso/jk/CameraDevice/list",
    method: "get",
    params: parameter
  });
}
// 获取用户权限
export function permissionList(parameter) {
  return request({
    url: "/auth/permission/list",
    method: "get",
    params: parameter
  });
}
// 云台开始
export function controlStart(parameter) {
  return request({
    url: "/sso/api/sso/jk/CameraDevice/start",
    method: "post",
    data: parameter
  });
}
// 云台结束
export function controlEnd(parameter) {
  return request({
    url: "/sso/api/sso/jk/CameraDevice/stop",
    method: "post",
    data: parameter
  });
}
// 根据工区查监控url
export function workareaIdVideo(parameter) {
  return request({
    url: "/ys7/getAllAtWorkAreaId",
    method: "get",
    params: parameter
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js